export default __webpack_public_path__ + "static/media/htmlcss_icon.a5275b10.png";